import { SearchOutlined } from '@ant-design/icons'
import { Input } from 'antd'
import { useIntl } from 'react-intl'
import { lang } from './lang'

type Props = {
  searchQuery: string
  onChange: (value: string) => void
}

export default function Search({ searchQuery, onChange }: Props) {
  const intl = useIntl()

  return (
    <Input
      size="large"
      prefix={<SearchOutlined style={{ color: 'var(--grey-600)' }} />}
      value={searchQuery}
      onChange={e => onChange(e.target.value)}
      placeholder={intl.formatMessage(lang.search)}
    />
  )
}
